import { useQuery } from '@hooks/reactQuery';

import { getGoldenSettingsDatesMavenir } from '@api/goldenSettings';

import { extractQueryParams } from '@utils/common';
import { parseStringDate } from '@utils/date';

import { TCMDatesMavenirDatesDTO } from '@interfaces/cmModule/dto/cmModuleDTO';

import { refetchOptions } from '@constants/common';
import { GOLDEN_SETTING_DATES_MAVENIR } from '@constants/queryKeys';

interface IUseQueryGoldenSettingsDatesMavenirReturnType {
	goldenSettingsDatesMavenir: Date[];
	isLoadingGoldenSettingsDatesMavenir: boolean;
}

const useQueryGoldenSettingsDatesMavenir = (
	params: Partial<TCMDatesMavenirDatesDTO>,
): IUseQueryGoldenSettingsDatesMavenirReturnType => {
	const {
		vendor,
		nodes,
		type,
		version,
	} = params;

	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [
			GOLDEN_SETTING_DATES_MAVENIR,
			params,
		],
		queryFn: extractQueryParams(getGoldenSettingsDatesMavenir),
		select: (data: string[]) => data.map((date) => parseStringDate(date)),
		enabled: [
			vendor,
			nodes,
			type,
			version,
		],
		...refetchOptions,
	});

	return {
		goldenSettingsDatesMavenir: data || [],
		isLoadingGoldenSettingsDatesMavenir: (isLoading && !!data)
			|| isFetching,
	};
};

export default useQueryGoldenSettingsDatesMavenir;
